export default __webpack_public_path__ + "static/media/home.781a7a30.svg";